import type { ButtonHTMLAttributes } from 'react';
import type { ImageAsset } from '@/assets/types';
import { cssVars } from '@/lib/cssVars';
import { cx } from '@/lib/cx';
import styles from './ImageButton.module.css';

interface ImageButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  image: ImageAsset;
  /** Accessible name; the image itself is decorative. */
  label: string;
  /** Width in design units. */
  size: number;
}

/** A button drawn entirely by a painted asset, with press and focus feedback. */
export function ImageButton({ image, label, size, className, style, ...rest }: ImageButtonProps) {
  return (
    <button
      type="button"
      aria-label={label}
      className={cx(styles.button, className)}
      style={{ ...cssVars({ '--size': size, '--aspect': image.width / image.height }), ...style }}
      {...rest}
    >
      <img src={image.url} width={image.width} height={image.height} alt="" draggable={false} />
    </button>
  );
}
